import PropTypes from 'prop-types';
import { useState, useEffect, useCallback } from 'react';

import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';

import { useAuthContext } from 'src/auth/hooks';

export default function SuperadminGuard({ children }) {
  const router = useRouter();
  const { authenticated, user } = useAuthContext();
  const [checked, setChecked] = useState(false);

  const check = useCallback(() => {
    if (!authenticated) {
      const searchParams = new URLSearchParams({ returnTo: window.location.pathname }).toString();
      const href = `${paths.auth.jwt.login}?${searchParams}`;
      router.replace(href);
      return;
    }

    // Vérification simple : l'utilisateur doit être un superadmin
    if (user?.role !== 'superadmin') {
      router.replace(paths.error.permissionDenied);
      return;
    }

    setChecked(true);
  }, [authenticated, user, router]);

  useEffect(() => {
    check();
  }, [check]);

  if (!checked) return null;

  return <>{children}</>;
}

SuperadminGuard.propTypes = {
  children: PropTypes.node,
};
